import { render } from "./sql-course.vue?vue&type=template&id=391c6559&scoped=true"
import script from "./sql-course.vue?vue&type=script&lang=js"
export * from "./sql-course.vue?vue&type=script&lang=js"

import "./sql-course.vue?vue&type=style&index=0&id=391c6559&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391c6559"]])

export default __exports__